import { CustomError } from "./custom-error";

export class CarTooExpensiveError extends CustomError {
  constructor(maxExchange: any) {
    super(`Der Preis darf ${maxExchange} EUR nicht überschreiten.`)

    Object.setPrototypeOf(this, CarTooExpensiveError.prototype);
  }
}
